import {FEATURE_FLAGS, MODULE_TYPES} from '../../../constants';
import {hasFeatureFlag} from './FeatureUtil';
import {hasModule} from './ModuleUtil';

/**
 * SIG-18: whether the Stream is *available* to the current company.
 *
 * Requires BOTH the `STREAM` module AND the `stream_feature` flag. This is deliberately AND, unlike
 * `isTicketingAvailable` / `isCustomerPortalAvailable` (module OR flag): the module is what is sold, the flag
 * gates the release and is retired at GA.
 *
 * Availability only. Callers check STREAM_VIEW / STREAM_CONTENT_MANAGE / STREAM_IMPORT alongside it.
 */
export const isStreamAvailable = (): boolean => hasModule(MODULE_TYPES.STREAM) && hasFeatureFlag(FEATURE_FLAGS.STREAM_FEATURE);
